import React from "react";

import { StoreContext } from "app/context/Store";
import { CHANGE_LANG } from "app/context/Types";

function LanguageSwitcher() {
  const context = React.useContext(StoreContext);

  const changeLang = (lang) => {
    localStorage.setItem("lang", lang);
    context.dispatch({ type: CHANGE_LANG, payload: lang });
  };

  return (
    <>
      <button className="btn btn-primary px-2" onClick={() => changeLang("hi")}>
        हिन्दी
      </button>
      <button className="btn btn-primary px-2" onClick={() => changeLang("en")}>
        English
      </button>
    </>
  );
}

export default LanguageSwitcher;
